<template>
  <div>
    <div class="marTML pf23-subTit">
      <div class="widM fntH4 bold padTS padBS" style="color:#fff;">액티비티 예약</div>
    </div>

    <div class="activeityScrollWrap marTML">
      <div class="activeityScroll">
        <img v-if="wave_number === 1" src="@/views/surveys/sydney/images/activity/activity_schedule_01.jpg" alt="스케쥴표">
        <img v-if="wave_number === 2" src="@/views/surveys/sydney/images/activity/activity_schedule_02.jpg" alt="스케쥴표">
        <img v-if="wave_number === 3" src="@/views/surveys/sydney/images/activity/activity_schedule_03.jpg" alt="스케쥴표">
        <img v-if="wave_number === 4" src="@/views/surveys/sydney/images/activity/activity_schedule_04.jpg" alt="스케쥴표">
        <img v-if="wave_number === 5" src="@/views/surveys/sydney/images/activity/activity_schedule_05.jpg" alt="스케쥴표">
        <img v-if="wave_number === 6" src="@/views/surveys/sydney/images/activity/activity_schedule_06.jpg" alt="스케쥴표">
        <img v-if="wave_number === 7" src="@/views/surveys/sydney/images/activity/activity_schedule_07.jpg" alt="스케쥴표">
        <img v-if="wave_number === 8" src="@/views/surveys/sydney/images/activity/activity_schedule_08.jpg" alt="스케쥴표">
      </div>
    </div>

    <div class="widM txtC marTML">
      <a @click="openActivityPopup" class="disIb fntH5 bold pf23-activeBtn" >
        액티비티 정보 안내 &nbsp;
        <img src="@/views/survey2/images/NCAcmi_arrow.png" alt="" class="verM" style="max-width:10px; width:2%;">
      </a>
      <p class="fntE txtL marTSM" style="color:#d91734;">* 액티비티 별 잔여인원은 제출 시간에 따라 차이가 있을 수 있습니다.</p>
    </div>

    <!-- <hr style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">-->

    <template v-for="(activity, sq_code, i) in activities">
      <SurveyActivityParticipant
        :key="`activity_${sq_code}`"
        :activity="activity"
        :is-first="i === 0"
      />
      <!-- <hr
        v-if="i < activityCount - 1"
        :key="`hr_${activity.sq_code}`"
        style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"> -->
    </template>
  </div>
</template>

<script>
import { CommonMethodMixin } from '../mixins'
import { SURVEY_SYDNEY, ACTIVITY_QUESTIONS, TOGGLE_ACTIVITY_POPUP } from '@/store/actions/survey'
import { mapGetters, mapState } from 'vuex'
import SurveyActivityParticipant from './SurveyActivityParticipant.vue'

export default {
  name: 'SurveyActivityList',
  mixins: [CommonMethodMixin],
  components: {
    SurveyActivityParticipant,
  },
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      wave_number: state => state.wave_number
    }),
    ...mapGetters(SURVEY_SYDNEY, {
      activities: ACTIVITY_QUESTIONS,
    }),
    activityCount() {
      return Object.keys(this.activities).length;
    }
  },
  methods: {
    openActivityPopup() {
      this.$store.commit(`${SURVEY_SYDNEY}/${TOGGLE_ACTIVITY_POPUP}`, true);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyActivityList.vue